const backendUrl = (process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000').replace(/\/$/, '');

export function getBackendUrl() {
  return backendUrl;
}

export async function apiFetch(path, { accessToken, method = 'GET', body } = {}) {
  const response = await fetch(`${backendUrl}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
    },
    ...(body !== undefined ? { body: JSON.stringify(body) } : {})
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(payload.error || 'Request failed');
    error.status = response.status;
    error.details = payload.details || null;
    throw error;
  }

  return payload;
}
